var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "da_" + _vm._.max([_vm._.size(_vm.asta_squadre), 1]),
        "cerchio",
        _vm.tavoloSize,
        "squadre" + _vm._.capitalize(_vm.squadreSize),
      ],
      attrs: { id: "tavolo-cerchio" },
    },
    [
      _c(
        "div",
        { attrs: { id: "cerchio" } },
        _vm._l(_vm.asta_squadre_array, function (sq) {
          return _c("squadra-tavolo", {
            key: sq.id,
            attrs: { id: sq.id, size: _vm.squadreSize },
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.asta_round.calciatoreInAsta
        ? _c("calciatore-su-tavolo", {
            attrs: { id: _vm.asta_round.calciatoreInAsta },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }